import { render } from "./NewCustomers.vue?vue&type=template&id=6441dcee&ts=true"
import script from "./NewCustomers.vue?vue&type=script&lang=ts"
export * from "./NewCustomers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__